import React, { useContext, useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import RootContext from '@/RootContext';
import CallAnalysisCard from '@/components/widgets/CallAnalysisCard';
import EngagementSummaryCard from '@/components/widgets/EngagementSummaryCard';
import AgentActionQueueCard from '@/components/widgets/AgentActionQueueCard';
import BookedRevenueCard from '@/components/widgets/BookedRevenueCard';
import { computeDashboardRange } from '@/utils/dashboardDateRange';
import './Home.scss';

const Home = () => {
  const location = useLocation();
  const rootContext = useContext(RootContext);
  const auth = rootContext.get('auth');
  const [isLoaded] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState('last 30 days');

  const range = useMemo(() => computeDashboardRange(selectedPeriod), [selectedPeriod]);

  if (!auth) {
    return <Navigate to="/sign_in" state={{ from: location }} replace />;
  }

  const firstName = auth?.given_name || 'User';

  if (!isLoaded) {
    return (
      <div className="loading-screen">
        <div className="spinner-container">
          <div className="loader-circle"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4 ps-4 pe-4">
      <div className="d-flex flex-wrap align-items-end gap-2">
        <div className="me-auto">
          <h2 className="mt-2 mb-1 fw-bold" style={{ fontSize: '1.25rem' }}>Hi, {firstName}!</h2>
          <p className="text-muted mb-0"> Your daily insights across all active trials</p>
        </div>

        <div>
          <select
            className="form-select form-select-sm w-auto"
            style={{
              backgroundColor: '#2E2868',
              color: '#f3e8ff',
              borderColor: '#d0bfff',
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg fill='white' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.646 6.646a.5.5 0 0 1 .708 0L8 9.293l2.646-2.647a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 0.75rem center',
              backgroundSize: '1rem',
              appearance: 'none',
              WebkitAppearance: 'none',
              MozAppearance: 'none',
            }}
            value={selectedPeriod}
            onChange={(event) => setSelectedPeriod(event.target.value)}
          >
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="last 7 days">Last 7 days</option>
            <option value="last 14 days">Last 14 days</option>
            <option value="last 30 days">Last 30 days</option>
          </select>
        </div>
      </div>

      <div className="row g-4 mt-1 align-items-stretch">
        <div className="col-md-6">
          <BookedRevenueCard startDate={range.start} endDate={range.end} selectedPeriod={selectedPeriod} />
        </div>

        <div className="col-md-6 ">
          <AgentActionQueueCard startDate={range.start} endDate={range.end} />
        </div>

        <div className="col-md-6 ">
          <CallAnalysisCard startDate={range.start} endDate={range.end} />
        </div>

        <div className="col-md-6  ">
          <EngagementSummaryCard
            startDate={range.start}
            endDate={range.end}
            selectedPeriod={selectedPeriod}
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
